import Vue from "vue";
import store from "./store";

// Import main views
import MosaicGrid from '@/views/MosaicGrid';

Vue.config.productionTip = false;

// Import our Stylesheets
import './styles/index.scss';

// Import any Plugins we want globally available in the application
import axios from './plugins/axios';

// Run Plugin functions
axios({ store, Vue });

const MosaicGridDiv = document.getElementById("mosaic-grid");
console.log('main.js MosaicGridDiv', MosaicGridDiv);
if (MosaicGridDiv) {
  new Vue({
    store,
    render: (h) => h(MosaicGrid),
  }).$mount('#mosaic-grid');
}
